var data = {
	"body": "<rect width=\"1700\" height=\"1360\" x=\"150\" y=\"-627.638\" rx=\"311.337\" ry=\"306\" fill=\"transparent\" stroke=\"currentColor\" stroke-width=\"220\" stroke-linecap=\"round\" transform=\"translate(0 947.638)\"/>",
	"width": 2000,
	"height": 2000
};
exports.__esModule = true;
exports.default = data;
